export default function WhyWorkWithMe() {
  const cards = [
    { value: '18+', label: 'лет практики', icon: 'ri-calendar-check-line', desc: 'Опыт в корпоративном обучении, развитии Soft Skills и управлении с 2005 года' },
    { value: '100+', label: 'корпоративных проектов', icon: 'ri-briefcase-4-line', desc: 'Реализованные проекты по развитию Soft Skills сотрудников в Беларуси, России, Казахстане и Израиле' },
    { value: '4500+', label: 'участников', icon: 'ri-group-line', desc: 'Руководители, менеджеры и специалисты прошли обучение по авторским программам' },
    { value: '450+', label: 'тренингов и бизнес-сессий', icon: 'ri-presentation-line', desc: 'Практические программы по коммуникациям, эмоциональному интеллекту и командной работе' },
    { value: '90+', label: 'стратегических сессий', icon: 'ri-compasses-2-line', desc: 'Фасилитация и стратегические сессии для топ-менеджмента компаний' },
    { value: '9,09/10', label: 'оценка участников', icon: 'ri-star-smile-line', desc: 'Средняя оценка по результатам анкетирования после обучения' },
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Почему компании работают именно со мной
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto">
          За 18 лет практики сложилась система, которая даёт измеримые результаты в развитии Soft Skills сотрудников и управленческих команд
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.map((card, i) => (
            <div key={i} className="bg-gray-50 p-7 rounded-xl hover:bg-teal-50 transition-colors group text-center">
              <div className="w-14 h-14 bg-teal-600 rounded-xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform">
                <i className={`${card.icon} text-2xl text-white`}></i>
              </div>
              <div className="text-3xl md:text-4xl font-extrabold text-teal-600 mb-2">{card.value}</div>
              <div className="font-semibold text-gray-900 text-sm mb-2">{card.label}</div>
              <p className="text-gray-600 text-xs leading-relaxed">{card.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}